import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Title from "./Title";
import {
  MdBatteryUnknown,
  MdBatteryAlert,
  MdBattery20,
  MdBattery30,
  MdBattery50,
  MdBattery60,
  MdBattery80,
  MdBattery90,
  MdBatteryFull,
} from "react-icons/md";
import Grid from "@material-ui/core/Grid";
import UltimaVez from "./ultimaVez";

const smallBatterySize = "150px";
const batterySize = "140px";

const redBattery = "#e76f51";
const yellowBattery = "#e9c46a";
const greenBattery = "#2a9d8f";
const greyBattery = "#666666";

const useStyles = makeStyles({
  div:{
    width:"100%", 
    height:"100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  root: {
    width: "100%",
    //height:"80%"
  },
  batteryBox: {
    width: "25%",
    margin: "0px"
  },
  batteryBoxSmall: {
    width: "35%",
    margin: "0px",
    display: "flex",
    flexDirection: "row",
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  batteryRed: {
    fontSize: batterySize,
    //transform: "rotate(90deg)",
    color: redBattery,
  },
  batteryYellow: {
    fontSize: batterySize,
    //transform: "rotate(90deg)",
    color: yellowBattery,
  },
  batteryGreen: {
    fontSize: batterySize,
    //transform: "rotate(90deg)",
    color: greenBattery,
  },
  batteryRedSmall: {
    fontSize: smallBatterySize,
    //transform: "rotate(90deg)",
    color: redBattery,
  },
  batteryYellowSmall: {
    fontSize: smallBatterySize,
    //transform: "rotate(90deg)",
    color: yellowBattery,
  },
  batteryGreenSmall: {
    fontSize: smallBatterySize,
    //transform: "rotate(90deg)",
    color: greenBattery,
  },
  batteryGrey: {
    fontSize: smallBatterySize,
    //transform: "rotate(90deg)",
    color: greyBattery,
  },
  batteryGreySmall: {
    fontSize: smallBatterySize,
    //transform: "rotate(90deg)",
    color: greyBattery,
  },
  depositContext: {
    flex: 1,
  },
  info: {
    width: "40%",
    height: "100%",
    margin: "0px",
    textAlign: "center",
    fontSize: "64px",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
  },
  infoWidget: {
    width: "50%",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignContent: "left",
    alignItems: "left",
    justifyContent: "center",
    fontSize: "36px",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    color: "#212121",
  },
  body: {
    width: "100%",
    height: "60%",
    display: "flex",
    alignItems: "center",
    alignContent: "center",
  },
});

export default function Bateria({ titulo, valor, registros, auditoria, widget={} }) {
  ///////////////////////////////////////////////////////////////
  //Variables para calcular el porcentaje de bateria 
  const [value, setValue] = React.useState(0);

  React.useEffect(() => {
          if (registros) {
              setValue(registros[0].valor)
          }
  }, [registros])

   
  let maxAllowed = 100
  let minAllowed = 0
  let max = widget.valorMaximo || 100
  let min = widget.valorMinimo || 0
  let valorActual = parseInt((maxAllowed - minAllowed) * (value - min) / (max - min) + minAllowed)

  const classes = useStyles();

  const drawBattery = (level, isWidget) => {
    if (level) {
      if (level < 30) {
        return (
          <MdBatteryAlert
            className={isWidget ? classes.batteryRedSmall : classes.batteryRed}
            size={isWidget ? "140px" : "140px"}
            color = { redBattery}
          />
        );
      /* } else if (level === "Media") {
        return (
          <MdBatteryAlert
            className={
              isWidget ? classes.batteryYellowSmall : classes.batteryYellow
            }
            size={"140px"}
          />
        );
      } else if (level  === "Alta") {
        return (
          <MdBattery20
            className={
              isWidget ? classes.batteryYellowSmall : classes.batteryYellow
            }
            size={"140px"}
          />
        ); */
      }else if (level >= 20 && level < 30) {
        return (
          <MdBattery20
            className={isWidget ? classes.batteryYellowSmall : classes.batteryYellow }
            size={isWidget ? "140px" : "140px"}
            color = { yellowBattery}
          />
        );
      } else if (level >= 30 && level < 50) {
        return (
          <MdBattery30
            className={isWidget ? classes.batteryYellowSmall : classes.batteryYellow }
            size={isWidget ? "140px" : "140px"}
            color = { yellowBattery}
          />
        );
      }else if (level >= 30 && level < 50) {
        return (
          <MdBattery50
            className={isWidget ? classes.batteryYellowSmall : classes.batteryYellow }
            size={isWidget ? "140px" : "140px"}
            color = { yellowBattery}
          />
        );
      } else if (level >= 50 && level < 60) {
        return (
          <MdBattery50
            className={
              isWidget ? classes.batteryGreenSmall : classes.batteryGreen
            }
            size={"140px"}
          />
        );
      } else if (level >= 60 && level < 80) {
        return (
          <MdBattery60
            className={
              isWidget ? classes.batteryGreenSmall : classes.batteryGreen
            }
            size={"140px"}
          />
        );
      } else if (level >= 80 && level < 90) {
        return (
          <MdBattery80
            className={
              isWidget ? classes.batteryGreenSmall : classes.batteryGreen
            }
            size={"140px"}
          />
        );
      } else if (level >= 90 && level < 100) {
        return (
          <MdBattery90
            className={
              isWidget ? classes.batteryGreenSmall : classes.batteryGreen
            }
            size={"140px"}
          />
        );
      } else if (level > 99) {
        return (
          <MdBatteryFull
            className={
              isWidget ? classes.batteryGreySmall : classes.batteryGrey
            }
            size={isWidget ? "140px" : "140px"}
            color = { greenBattery}
          />
        );
      } else {
        return (
          <MdBatteryUnknown
            className={isWidget ? classes.batteryGrey : classes.batteryGrey}
            size={isWidget ? "140px" : "140px"}
          />
        );
      }
    } else {
      return (
        <MdBatteryUnknown
          className={isWidget ? classes.batteryGrey : classes.batteryGrey}
          size={isWidget ? "140px" : "140px"}
        />
      );
    }
  };

  return (
    <div className={auditoria ? null: classes.div }>
       {auditoria &&
       <div className={classes.root}>
          <span className="dragWidget">
            <Title>{titulo}</Title>
          </span>
        </div>}
      <Grid container direction="row"  justifyContent="space-between" alignItems="center" >
          {auditoria ? (
            <div className={classes.batteryBoxSmall}>
              {drawBattery(valorActual, true)}
            </div>
          ) : (
            <div className={classes.batteryBox}>{drawBattery(valorActual)}</div>
          )}
          {auditoria ? (
            <div className={classes.infoWidget}>
              <p style={{ fontSize:"14px", margin: "0px", color: "#666666" }}>Nivel de batería:</p>
              <p style={{ margin: "0px", color: "#666666" }}>{`${valorActual}`+ " %"}</p>
            </div>
          ) : (
            <div className={classes.info}>
              {valorActual ? (
                <>
                <p style={{ fontSize:"16px", margin: "0px", color: "#666666" }}>Nivel de batería:</p>
                <p style={{  fontSize:"40px", marginTop: "0px", color: "#666666" }}>{`${valorActual}`}</p>
                </>
              ) : (
                <>
                  <p style={{ color: "#666666", fontSize: "25px", margin: 0 }}>
                    No se registran
                  </p>
                  <p style={{ color: "#666666", fontSize: "25px", margin: 0 }}>
                    datos
                  </p>
                </>
              )}
            </div>
          )}
          <div className={classes.depositContext}>
              <UltimaVez auditoria ={auditoria}/>
          </div>
      </Grid>
    </div>
  );
}
